<template>
  <div class="flex items-center">
    <input
      v-model="radioVal"
      :value="props.value"
      :name="props.name"
      :disabled="props.disabled"
      type="radio"
      class="hidden h-4 w-4 text-cdp-main-primary accent-cdp-main-primary"
    />
    <button :disabled="props.disabled" @click="selected()">
      <icon
        v-show="radioVal === props.value && !props.disabled"
        name="ic_radio_on_normal"
        class="h-6 w-6 text-cdp-main-primary"
      />
      <icon
        v-show="radioVal !== props.value && !props.disabled"
        name="ic_radio_off_normal"
        class="h-6 w-6 text-cdp-grey-400"
      />
      <icon
        v-show="radioVal === props.value && props.disabled"
        name="ic_radio_on_disable"
        class="h-6 w-6 text-cdp-black-200"
      />
      <icon
        v-show="radioVal !== props.value && props.disabled"
        name="ic_radio_off_disable"
        class="h-6 w-6 text-cdp-black-200"
      />
    </button>
    <label :for="props.name" class="mx-2 font-normal text-cdp-black-500">
      <slot name="text">
        {{ props.text }}
      </slot>
    </label>
  </div>
</template>

<script>
import { computed, defineComponent } from 'vue';
export default defineComponent({
  name: 'ComponentsRadio',
  props: {
    modelValue: {
      type: [String, Number],
      default: ''
    },
    value: {
      type: [String, Number],
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: () => [
        {
          text: String,
          value: Number
        }
      ]
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'change'],
  setup(props, { emit }) {
    const radioVal = computed({
      get: () => props.modelValue,
      set: (val) => {
        emit('update:modelValue', val);
        emit('change', val);
      }
    });

    function selected() {
      if (props.disabled) return false;
      radioVal.value = props.value;
    }

    return {
      props,
      radioVal,
      selected
    };
  }
});
</script>